const plugin = require('tailwindcss/plugin');
// TODO: is this good file structure lol
const { componentStyles } = require('./src/components/components.styles');

const green1 = {
  80: '#273E36',
  75: '#29483F',
  70: '#2C4E43',
  65: '#385B50',
  60: '#42675C',
  55: '#497265',
  50: '#567F71',
  45: '#5F8E7D',
  40: '#6B9C8B',
  35: '#83B2A3',
  30: '#9DC2B7',
  25: '#B0D1C7',
  20: '#CBDFD9',
  15: '#DEEEE8',
  10: '#E9F8F2',
};

module.exports = {
  mode: 'jit',
  purge: ['./src/**/*.{js,jsx,ts,tsx}'],
  // https://tailwindcss.com/docs/preflight
  // Turn off preflight so that basic styles don't interfere
  // with existing styles
  corePlugins: {
    preflight: false,
  },
  theme: {
    screens: {
      xxs: '360px',
      xs: '480px',
      sm: '576px',
      'sm-max': { max: '767px' },
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1600px',
    },
    colors: {
      inherit: 'inherit',
      transparent: 'transparent',
      black: '#131516',
      white: '#FFFFFF',
      grey: {
        75: '#3E4145',
        65: '#505357',
        60: '#5B5F63',
        55: '#6B6D70',
        50: '#73777C',
        45: '#848689',
        40: '#939597',
        30: '#B6B8BC',
        25: '#C9CACC',
        20: '#D9DADD',
        15: '#E9E9EB',
        10: '#F7F7F8',
      },
      green1,
      green2: {
        55: '#197E5F',
        50: '#218664',
        45: '#30966F',
        40: '#3EA378',
        35: '#54BA8C',
        30: '#68CD9D',
        25: '#72E6AF',
      },
      blue1: {
        80: '#223E50',
        75: '#27465B',
        70: '#2B4C61',
        65: '#325971',
        60: '#3A6680',
        55: '#46738D',
        50: '#4D7C98',
        45: '#608EA9',
        40: '#6C9AB7',
        35: '#88AFC7',
        30: '#9ABED5',
        25: '#B7D3E3',
        20: '#CDE3EE',
        15: '#DFECF3',
        10: '#EBF4F9',
      },
      infoblue: {
        10: '#E8F8FF',
        60: '#0376b3',
      },
      orange1: {
        35: '#DF9A40',
        30: '#F4B34C',
        25: '#FBC56D',
        23: '#FECF82',
        20: '#FDD895',
        15: '#FCE8C5',
        10: '#FBF5EB',
      },
      beige1: {
        15: '#EDE3E1',
        10: '#F8F4F3',
      },
      alertred: {
        60: '#CA3C26',
        10: '#FFF2F0',
      },
      red: {
        100: '#F53135',
      },
      charts: {
        grey: {
          40: '#636F75',
          30: '#8B98A0',
          20: '#C7D1D7',
          10: '#E7EDF2',
        },
        purple: {
          40: '#A956D1',
          30: '#C58DE0',
          20: '#DCBAED',
          10: '#EBD6F4',
        },
      },
    },
    boxShadow: {
      5: '0px 8px 20px rgba(19, 21, 22, 0.05)',
      10: '0px 3px 18px rgba(19, 21, 22, 0.1)',
      15: '0px 2px 14px rgba(19, 21, 22, 0.15)',
      20: '0px 1px 24px 1px rgba(19, 21, 22, 0.2)',
      50: '0px 0px 50px 0px rgba(19, 21, 22, 0.5)',
      none: 'none',
    },
    extend: {
      animation: {
        enter: 'fadeIn 350ms ease-out',
        leave: 'fadeOut 350ms ease-in forwards',
        pulse: 'pulse 2s cubic-bezier(0.5, 2, 0.6, 2) infinite',
        'pulse-alternate': 'pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite',
      },
      keyframes: {
        fadeIn: {
          '0%': { opacity: '0' },
          '100%': { opacity: '1' },
        },
        fadeOut: {
          '0%': { opacity: '1', transform: 'translate(0)' },
          '100%': { opacity: '0', transform: 'translate(250%)' },
        },
        'pulse-alternate': {
          '0%, 100%': {
            opacity: '1',
          },
          '50%': {
            opacity: '0.75',
          }
        }
      },
      fontFamily: {
        default: ['CentraNo1', 'Roboto', 'serif'],
      },
      gridTemplateColumns: {
        'time-selector': 'repeat(auto-fill, minmax(88px, 1fr))',
      },
      zIndex: {
        1: '1',
        // Dummy values
        'details-tabs': '0',
        cubby: '0',
        'cubby-overlay': '0',
      },
      backdropBlur: {
        xs: '2px',
      },
      spacing: {
        // TODO: These dummy values are needed to build properly, because
        // they are not defined in the patient app's individual tailwind.config,
        // but are accessed via custom values using theme() in some compnents
        // used in the clinician and admin apps.
        // With our current setup, all 3 apps purge the core folder,
        // causing a build error in the patient app.
        // See if there is a way to get around this.
        'app-header-height': '0px',
        'patient-details-tabs-height': '0px',
        'intake-form-tabs-height': '0px',
      },
      flexBasis: {
        '1/2': '50%',
      },
      fill: {
        white: '#fff',
        green1,
      },
    },
  },
  plugins: [
    plugin(function ({ addComponents, theme }) {
      addComponents(componentStyles(theme));
    }),
  ],
};
